import { render } from "./Deposit.vue?vue&type=template&id=73852462&scoped=true"
import script from "./Deposit.vue?vue&type=script&lang=js"
export * from "./Deposit.vue?vue&type=script&lang=js"

import "./Deposit.vue?vue&type=style&index=0&id=73852462&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73852462"]])

export default __exports__